import React, { useCallback, useEffect, useState } from 'react'
import { Input, FormCustom, TextArea } from '../../Components/Form/Form'
import Controllers from '../../Api/Controllers'
import Loading from '../../Components/Layout/Styled/Loading';
import Helpers from '../../Components/Helpers/Helpers';
import { HonestWeekPicker } from './HonestWeekPicker';
import { addMonths, endOfWeek, startOfWeek, subMonths } from "date-fns";

const ViaticosForm = ({ data, onSubmit, disablebSubmit, loadSubmit, disabled }) => {
    const [viaticos, setViaticos] = useState([])
    const [row, setRow] = useState({
        date_end_viaticos_doc: startOfWeek(new Date(), { weekStartsOn: 1 }),
        date_start_viaticos_doc: endOfWeek(new Date(), { weekStartsOn: 1 }),
        id_viaticos_doc: data.id_viaticos,
        observation: '',
        new_observation: '',
    });
    const [loading, setLoading] = useState(true)

    const onChange = (week) => {
        setRow({
            ...row,
            date_start_viaticos_doc: Helpers.date.get({
                format: '%Y-%m-%d',
                startDate: week.firstDay
            }),
            date_end_viaticos_doc: Helpers.date.get({
                format: '%Y-%m-%d',
                startDate: week.lastDay
            })
        })
    };

    useEffect(() => {
        Controllers.viaticos.get_viaticos_doc_id({
            p_id_viaticos_doc: data.id_viaticos_doc
        }).then(res => {
            setViaticos(res.data.details.map(v => {
                v.details = v.details.map(d => {
                    d.subtotal = calculateSubtotal(d)
                    return d
                })
                return v
            }))
            console.log('res.data.viaticos', res.data.viaticos)
            setRow(res.data.viaticos)

            setLoading(false)
        })
    }, [])

    const renderInput = (v, d, keyName) => {
        return <Input
            type="number"
            value={d['day_' + keyName]}
            className="text-center"
            onChange={e => {
                let $this = e.currentTarget
                let value = $this.value
                setViaticos(viaticos.map(v1 => {
                    if (v1.id_viaticos === v.id_viaticos) {
                        v1.details = v1.details.map(d1 => {
                            if (d1.id_viaticos === d.id_viaticos) {
                                d1['day_' + keyName] = value
                                d1.subtotal = calculateSubtotal(d1)
                            }
                            return d1
                        })
                    }
                    return v1
                }))
            }}
            style={{
                minWidth: 100
            }}
            min="0.0001"
            step="0.0001"
            disabled={disabled}
        />
    }

    const calculateSubtotal = d => {
        let subtotal = 0
        subtotal += (!isNaN(parseFloat(d.day_1))) ? parseFloat(d.day_1) : 0
        subtotal += (!isNaN(parseFloat(d.day_2))) ? parseFloat(d.day_2) : 0
        subtotal += (!isNaN(parseFloat(d.day_3))) ? parseFloat(d.day_3) : 0
        subtotal += (!isNaN(parseFloat(d.day_4))) ? parseFloat(d.day_4) : 0
        subtotal += (!isNaN(parseFloat(d.day_5))) ? parseFloat(d.day_5) : 0
        subtotal += (!isNaN(parseFloat(d.day_6))) ? parseFloat(d.day_6) : 0
        subtotal += (!isNaN(parseFloat(d.day_7))) ? parseFloat(d.day_7) : 0
        return subtotal
    }

    const formatDetails = useCallback(_ => {
        const viaticosDet = [];
        viaticos.forEach(vt => {
            vt.details.forEach(d => {
                if (d.parent_id) {
                    if (d.subtotal > 0) {
                        for (let i = 1; i <= 7; i++) {
                            if (!isNaN(parseFloat(d['day_' + i]))) {
                                viaticosDet.push({
                                    id_viaticos: d.id_viaticos,
                                    day_number: i,
                                    subtotal: d['day_' + i]
                                })
                            }
                        }
                    }
                }
            })
        })

        return viaticosDet
    }, [viaticos])

    if (loading) {
        return <Loading show={loading}>
            <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
        </Loading>
    }

    return <FormCustom onSubmit={_ => {
        const viaticosDet = formatDetails()

        const dataRecord = {
            p_id_viaticos_doc: row.id_viaticos_doc ? row.id_viaticos_doc : '',
            p_total_viaticos_doc: viaticosDet.reduce((a, b) => a + parseFloat(b.subtotal), 0),
            p_date_start_viaticos_doc: row.date_start_viaticos_doc,
            p_date_end_viaticos_doc: row.date_end_viaticos_doc,
            p_viaticos: viaticosDet,
            p_observation: row.new_observation
        }
        console.log('dataRecord', dataRecord)

        onSubmit({ data: dataRecord })
    }} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit} viewSubmit={!disabled}>


        {isNaN(parseInt(row.id_viaticos_doc)) ? <>
            <div className="col-12 mb-2">
                <label className='text-muted'>Seleccionar semana</label>
                <HonestWeekPicker onChange={onChange} />
            </div>
        </> : <>
            {row.observation && <div className='col-12 mb-2'>
                <div>Último motivo de modificación: {row.observation}</div>
            </div>}

            {!disabled && parseInt(row.status_viaticos_doc) === 2 && <TextArea
                classNameParent="col-12 mb-2"
                text="Motivo de modificación"
                required
                rows={5}
                onChange={e => setRow({
                    ...row,
                    new_observation: e.currentTarget.value
                })}
                disabled={disabled}
            />}

            <Input classNameParent="col-md-6 mb-3"
                text="Fecha Inicio"
                value={row.date_start_viaticos_doc}
                type="date"
                disabled
            />

            <Input classNameParent="col-md-6 mb-3"
                text="Fecha Fin"
                value={row.date_end_viaticos_doc}
                type="date"
                required
                disabled
            />
        </>}

        <div className="table-responsive">
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <td>Descripción del gasto</td>
                        <td>Lunes</td>
                        <td>Martes</td>
                        <td>Miércoles</td>
                        <td>Jueves</td>
                        <td>Viernes</td>
                        <td>Sábado</td>
                        <td>Domingo</td>
                        <td>Subtotal</td>
                    </tr>
                </thead>
                <tbody>
                    {React.Children.toArray(viaticos.map((d) => {
                        return <>
                            <tr>
                                <td><strong>{d.name_viaticos}</strong></td>
                                <td colSpan={8}></td>
                            </tr>
                            {React.Children.toArray(d.details.map((v) => {
                                return <tr>
                                    <td>{v.name_viaticos}</td>
                                    <td>
                                        {renderInput(d, v, 2)}
                                    </td>
                                    <td>
                                        {renderInput(d, v, 3)}
                                    </td>
                                    <td>
                                        {renderInput(d, v, 4)}
                                    </td>
                                    <td>
                                        {renderInput(d, v, 5)}
                                    </td>
                                    <td>
                                        {renderInput(d, v, 6)}
                                    </td>
                                    <td>
                                        {renderInput(d, v, 7)}
                                    </td>
                                    <td>
                                        {renderInput(d, v, 1)}
                                    </td>
                                    <td className='text-center'>
                                        {v.subtotal.toFixed(2)}
                                    </td>
                                </tr>
                            }))}
                        </>
                    }))}
                </tbody>
            </table>
        </div>
        <div className='mt-2 mb-2 d-flex justify-content-center w-100'>
            <h3>Total: <strong>{formatDetails().reduce((a, b) => a + parseFloat(b.subtotal), 0).toFixed(2)}</strong></h3>
        </div>
    </FormCustom>
}

ViaticosForm.defaultProps = {
    data: {
        id_viaticos_doc: ''
    },
    disabled: false,
    onSubmit: () => { },
    loadSubmit: false
}

export default ViaticosForm;